<div class="flex flex-col flex-1 min-h-0">
  @if (!addendumId()) {
    <dsm-aps-deposits-financial-summary [summary]="summary()" />
  }

  <div class="flex-1 min-h-0 flex flex-col">
    <dsm-aps-deposits-table
      [addendumView]="!!addendumId()"
      (depositsSaved)="onDepositFormSubmitted()"
      (depositPayment)="onDepositPaymentFormSubmitted($event)"
      [deposits]="deposits()"
      (deleteDeposit)="onConfirmDeleteDeposit()"
      (deleteDepositPayment)="onConfirmDeleteDepositPayment()"
      (bulkDeleteDeposits)="onBulkDeleteDeposits($event)"
      (importFrom)="openImportsModal('lots')"
    />
  </div>
</div>

<p-dialog
  header="Import Deposits"
  [visible]="importsDialogVisible()"
  (visibleChange)="importsDialogVisible.set($event)"
  [modal]="true"
  [style]="{ width: '40rem' }"
  [closable]="true"
  (onHide)="closeImportsDialog()"
>
  <dsm-aps-deposits-imports [importType]="importType()" (selectedLot)="onSelectedLot($event)" />
  <ng-template #footer>
    <div class="flex justify-end gap-2 pt-2">
      <p-button label="Cancel" severity="secondary" [outlined]="true" (onClick)="closeImportsDialog()" />
      <p-button label="Import" severity="primary" icon="pi pi-check" (onClick)="onImportData()" />
    </div>
  </ng-template>
</p-dialog>

<p-confirmdialog appendTo="body" />
